import { render, staticRenderFns } from "./LockdownPlayer.vue?vue&type=template&id=e88f68f6&scoped=true&"
import script from "./LockdownPlayer.vue?vue&type=script&lang=js&"
export * from "./LockdownPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88f68f6",
  null
  
)

export default component.exports